import isArray from 'lodash/isArray';
import { EXPAND_APP_PLATFORM_LIST } from '@/utils/apps';

export function validateWidgetAccess (definition, { getAppById, hasViewerPermission }) {
    if (!hasViewerPermission) {
        return true;
    }

    const checkAppAccess = (appId) => {
        if (!appId) return true;

        const appIds = isArray(appId) ? appId : [appId];

        return appIds.every((id) => !id || getAppById(id) || EXPAND_APP_PLATFORM_LIST.includes(id));
    };

    let hasAccess = true;

    if ('appId' in definition) {
        hasAccess = checkAppAccess(definition.appId);
    }
    if ('events' in definition && definition.events) {
        hasAccess = hasAccess && Object.values(definition.events).every((event) => {
            if (!event || !('appId' in event)) return true;

            return checkAppAccess(event.appId);
        });
    }
    if ('tags' in definition && definition.tags) {
        hasAccess = hasAccess && definition.tags.every((tag) => {
            if (!tag || !('appId' in tag)) return true;

            return checkAppAccess(tag.appId);
        });
    }

    return hasAccess;
}
